function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.6338 0.292999C24.3994 0.10545 24.0815 5.66374e-05 23.75 0H3.75C2.75544 0 1.80161 0.31607 1.09835 0.878679C0.395088 1.44129 0 2.20435 0 3V27C0 27.7956 0.395088 28.5587 1.09835 29.1213C1.80161 29.6839 2.75544 30 3.75 30H26.25C27.2446 30 28.1984 29.6839 28.9016 29.1213C29.6049 28.5587 30 27.7956 30 27V5C29.9999 4.73481 29.8682 4.48049 29.6338 4.293L24.6338 0.292999ZM27.5 5.414V6H25C24.6685 6 24.3505 5.89464 24.1161 5.70711C23.8817 5.51957 23.75 5.26522 23.75 5V2.414L27.5 5.414ZM26.25 28H3.75C3.41848 28 3.10054 27.8946 2.86612 27.7071C2.6317 27.5196 2.5 27.2652 2.5 27V3C2.5 2.73478 2.6317 2.48043 2.86612 2.29289C3.10054 2.10536 3.41848 2 3.75 2H21.25V5C21.25 5.79565 21.6451 6.55871 22.3484 7.12132C23.0516 7.68393 24.0054 8 25 8H27.5V27C27.5 27.2652 27.3683 27.5196 27.1339 27.7071C26.8995 27.8946 26.5815 28 26.25 28Z",
  fill: "url(#paint25_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5 10H25V12H5V10Z",
  fill: "url(#paint26_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5 14H25V16H5V14Z",
  fill: "url(#paint27_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5 18H25V20H5V18Z",
  fill: "url(#paint28_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M5 22H25V24H5V22Z",
  fill: "url(#paint29_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint25_linear",
  x1: 15,
  y1: 0,
  x2: 15,
  y2: 30,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint26_linear",
  x1: 15,
  y1: 10,
  x2: 15,
  y2: 12,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint27_linear",
  x1: 15,
  y1: 14,
  x2: 15,
  y2: 16,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint28_linear",
  x1: 15,
  y1: 18,
  x2: 15,
  y2: 20,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint29_linear",
  x1: 15,
  y1: 22,
  x2: 15,
  y2: 24,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})));

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 60,
    viewBox: "0 0 30 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.467462eb.svg";
export { ForwardRef as ReactComponent };